'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _components = require('../../components');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _messageModal = require('../../redux/modules/messageModal');
var _contactFormModal = require('../../redux/modules/contactFormModal');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

RealtorLandingPage = function (_Component) {_inherits(RealtorLandingPage, _Component);function RealtorLandingPage() {_classCallCheck(this, RealtorLandingPage);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}RealtorLandingPage.prototype.
  render = function render() {
    return (
      _react2.default.createElement(_components.RealtorLanding, this.props));

  };return RealtorLandingPage;}(_react.Component);


RealtorLandingPage.propTypes = {
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'RealtorLanding'),
    packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'RealtorPackages'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    isMobile: state.windowDimentions.isMobile };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  openContactFormModal: _contactFormModal.openContactFormModal,
  hideContactFormModal: _contactFormModal.hideContactFormModal })(

RealtorLandingPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/RealtorLandingPage/RealtorLandingPage.js
// module id = 3104
// module chunks = 0